import { showToastBarte } from "@/contexts/ToastContext";

interface ToastProps {
  message: string;
  type?: "warning" | "success" | "error" | "info" ;
  title?: string;
}

export const showToast = ({ message, type = "error", title }: ToastProps) =>
  showToastBarte({
    message,
    type,
    title,
  });


